import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ceo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  async (response) => {
    // One integration point for every CEO workflow that creates a visit (Centro de
    // Eficiência, Agenda Inteligente and pré-proposta). If the current user connected
    // Outlook, a scheduled visit is mirrored automatically. Missing/disconnected
    // Outlook never turns a successful CEO visit creation into an error.
    const method = String(response.config?.method || "").toLowerCase();
    const url = String(response.config?.url || "").split("?")[0];
    const visitId = response.data?.id;
    const scheduledAt = response.data?.scheduled_at;
    if (method === "post" && url === "/operations/visits" && visitId && scheduledAt) {
      try {
        await api.post(`/integrations/outlook/visits/${visitId}/sync`);
      } catch (syncError) {
        const status = syncError.response?.status;
        // 409 = Outlook not connected; 422 = visit cannot be represented yet;
        // 503 = Microsoft integration not configured. All are safe fallbacks.
        if (![409, 422, 503].includes(status)) {
          console.warn("CEO: Outlook auto-sync failed", status || syncError.message);
        }
      }
    }
    return response;
  },
  (err) => {
    if (err.response?.status === 401) {
      const url = err.config?.url || "";
      if (!url.includes("/auth/") && !url.includes("/fire/portal/") && !url.includes("/fire/public/") && !url.includes("/operations/public/")) {
        localStorage.removeItem("ceo_token");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;

